import React, { Component } from 'react';
import './index.css';
import {Link} from 'react-router-dom';
import IndexThumb from '../projects/indexThumb.js';




class Index extends Component {
    constructor(){
        super();
        this.timer = null;
        this.indexRef = null;
        this.state = {
            data:[]
        }

    };


    componentDidMount(){
      
    }


   

    render() {
        const { data } = this.props;
        const {win} = this.props;
        const {initPro} = this.props;
        const { hover } = this.props;
        const { proActive } = this.props;
        const {rep} = this.props;
        const {isMobile} = this.props;
    return (
     
    
      <React.Fragment>
          
        <div id="indexContain" className={`relative bgWhite ${proActive?'hide':''} ${rep?'repActive':''}`} style={{width:win[0],height:rep?"100%":"auto", minHeight:win[1]}} ref={element => this.indexRef = element}>
                

                
                {data.length?(
                    <React.Fragment >
                            <div className={`indexNames fullStage eCenter ptHuge pbHuge`}>
                                    {data.map((title,t)=>{
                                        return(
                                            <Link key={`indexlink-${title.id}`} onClick={initPro.bind(this)} className="fullWidth indexLink" to={`/work/${title.slug}`} >
                                                <div id={`thumb-${t}`} className="singleIndexPro bBot bWhite bBotSm ptMed pbMed" onMouseOut={isMobile?(null):(this.props.deCrawl.bind(this))} onMouseOver={isMobile?(null):(this.props.initCrawl.bind(this))} data-item={title.media.length} data-id={t} data-info={`${title.title} ————— ${title.client}`}>
                                                    <div className="singleIndex fullWidth plMed prMed eCenter tWhite tUpper flex">
                                                        <div>
                                                        {/* <h1>{title.title}</h1>
                                                        <h2>{title.client}</h2> */}
                                                        <p className="tCaption">{title.title} {title.client?(
                                                            <React.Fragment>
                                                            <span>— </span><span className="clientWrap">{title.client}</span>
                                                            </React.Fragment>
                                                        ):('')}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                   
                                            </Link>
                                        )
                                    })}

                            </div>
                            <div className="indexScreenHold" style={{width: win[0], height: win[1]}}>
                            {data.map((item,i)=>{
                                return(
                                    
                                            <IndexThumb titleCase={this.props.titleCase}  hover={this.props.hover} image={this.props.image} item={item} i={i} getImg={this.props.getImg}  initPro={initPro} win={win}/>
                                )
                            })}
                            </div>
                        </React.Fragment>
                ):('')}
                

            </div>
                

    
       </React.Fragment>
    
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/index/index.js